import React from 'react';
import { number, shape } from 'prop-types';
import TooltipPositioner from './TooltipPositioner';
import Tooltip from './GenericTooltipContainer';

const PositionedGenericTooltip = ({ x, y, bounds, circleRadius, ...props }) => {
  return (
    <TooltipPositioner
      x={x}
      y={y}
      padding={{ x: -circleRadius, y: circleRadius + 8 }}
      container={{
        left: bounds.padding,
        right: bounds.width - bounds.padding,
        top: bounds.padding,
        bottom: bounds.height - bounds.padding,
      }}
    >
      <Tooltip {...props} />
    </TooltipPositioner>
  );
};

PositionedGenericTooltip.propTypes = {
  x: number.isRequired,
  y: number.isRequired,
  // FIXME: This being an object as opposed to separate props
  // makes it hard to write defaultProps or handle fallbacks
  bounds: shape({
    width: number.isRequired,
    height: number.isRequired,
    padding: number.isRequired,
  }).isRequired,
  circleRadius: number,
  ...Tooltip.propTypes,
};

PositionedGenericTooltip.defaultProps = {
  x: 0,
  y: 0,
  circleRadius: 0,
};

export default PositionedGenericTooltip;



// WEBPACK FOOTER //
// ./src/components/GenericTooltip/PositionedTooltip.jsx